import React from 'react';
import c from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import ThumbStatusIndicator from '@wix/da-ds/pkg/thumbs/ThumbStatusIndicator';
import { ThumbStatusTypes } from '@wix/da-ds/pkg/thumbs/types';
import s from './Card.scss';

interface Props {
  badgeType: ThumbStatusTypes;
  children: React.ReactNode;
  className?: string;
}

const Card: React.FC<Props> = ({ badgeType, children, className }) => {
  return (
    <Section className={c(s['root'], className)}>
      <ThumbStatusIndicator type={badgeType} size="large" className={s['badge']} />
      {children}
    </Section>
  );
};

Card.displayName = 'Card';

export default Card;
